import React, { Component } from 'react';
import classes from "./TextPersonSpecies.module.css";

export default class TextPersonSpecies extends Component {

    render() {
        // const { data, labels } = this.state;
        return (
            <div className={classes.container}>
                
                <p className="text-anal">Fun game play can be derived from being familiar enough so that players are comfortable with the game but unexpected enough to make it feel fresh and new. Animal Crossing manages to do this by having the Villagers have quirky personalities, but it also plays into expected stereotypes of animals. For example, a Rabbit is cute and fun. While a Lion is manly and strong.</p>
        
                <p className="text-anal">Data Science can be used to find the most diverse Villager based on Personality and Gender. For example, since there are few Sisterly villagers, a player would need to work hard to invite her to his island while also trying to find a Species that is rare such as the Cow or Octopus. In addition, charts can quickly help the audience to process this data. The visualization of the data can also tell us if any data is missing like how many Kangeroos exist. </p> 

            </div>
        )
    }
}

/* Tutorial from:
     https://blog.bitsrc.io/customizing-chart-js-in-react-2199fa81530a
*/